export { default } from './AccordionDetailsView';
